import React from 'react';
import classNames from 'classnames';
import styles from './Textarea.module.scss';

interface TextareaProps extends React.InputHTMLAttributes<HTMLTextAreaElement> {
  label?: string;
  error?: string;
  fieldType?: string;
  title?: string;
  IconRight?: React.FC<any>;
}

const Textarea: React.FC<TextareaProps> = ({
  label,
  error,
  title,
  onChange,
  className,
  ...restProps
}) => {
  const handleChange = (event) => {
    let { value } = event.target;

    value = value.replace(/[<>/\\|^&]/g, '');
    return !!onChange && onChange(value);
  };
  return (
    <div
      className={classNames(['input-field', styles.inputField, className])}
      itemScope
      itemType='https://schema.org/Text'
    >
      {title && <span className={styles.title}>{title}</span>}
      {label && <span className={`label ${styles.inputLabel}`}>{label}</span>}
      <textarea
        aria-label={label}
        {...restProps}
        className={classNames([
          'input',
          styles.inputFieldItem,
          { [styles.errorInput]: !!error },
        ])}
        onChange={handleChange}
      />
      {error && <div className={styles.error}>{error}</div>}
    </div>
  );
};

export default Textarea;
